export enum FolderType {
  Company = "01",
  Department = "02",
}

export interface RecommendationItemResponse {
  companyFolders: RecommendationItemFolder[];
  departmentFolders: RecommendationItemFolder[];
}

export interface RecommendationItemFolder {
  childFolders: RecommendationItemFolder[];
  folderInformation: RecommendationFolderInformation;
}

export interface RecommendationFolderInformation {
  folderId: string;
  folderName: string;
  parentFolderId: string;
  count: number;
  sortOrder: number;
}
